import { apiSlice } from "../../app/api/apiSlice";

const NEWS_URL = "/news";
const SYSTEM_NEWS_URL = "/news/system";

export const newsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getNews: builder.query({
      query: () => NEWS_URL,
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ _id }) => ({ type: "News", id: _id })),
              { type: "News", id: "LIST" },
            ]
          : [{ type: "News", id: "LIST" }],
    }),
    getSystemNews: builder.query({
      query: () => SYSTEM_NEWS_URL,
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ _id }) => ({ type: "News", id: _id })),
              { type: "News", id: "SYSTEM_LIST" },
            ]
          : [{ type: "News", id: "SYSTEM_LIST" }],
    }),
    getNewsById: builder.query({
      query: (id) => `${NEWS_URL}/${id}`,
      providesTags: (result, error, id) => [{ type: "News", id }],
    }),
    updateNewsUserState: builder.mutation({
      query: ({ id, ...patch }) => ({
        url: `${NEWS_URL}/state/${id}`,
        method: "PATCH",
        body: patch,
      }),
      invalidatesTags: (result, error, payload) => [
        { type: "News", id: payload?.id },
        { type: "News", id: "LIST" },
        { type: "News", id: "SYSTEM_LIST" },
      ],
    }),
    createNews: builder.mutation({
      query: (payload) => ({
        url: payload?.isSystemAnnouncement ? SYSTEM_NEWS_URL : NEWS_URL,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: [{ type: "News", id: "LIST" }, { type: "News", id: "SYSTEM_LIST" }],
    }),
    updateNews: builder.mutation({
      query: (payload) => ({
        url: payload?.isSystemAnnouncement ? SYSTEM_NEWS_URL : NEWS_URL,
        method: "PATCH",
        body: payload,
      }),
      invalidatesTags: (result, error, payload) => [
        { type: "News", id: payload?.id },
        { type: "News", id: "LIST" },
        { type: "News", id: "SYSTEM_LIST" },
      ],
    }),
    deleteNews: builder.mutation({
      query: ({ id, isSystemAnnouncement }) => ({
        url: isSystemAnnouncement ? SYSTEM_NEWS_URL : NEWS_URL,
        method: "DELETE",
        body: { id },
      }),
      invalidatesTags: (result, error, payload) => [
        { type: "News", id: payload?.id },
        { type: "News", id: "LIST" },
        { type: "News", id: "SYSTEM_LIST" },
      ],
    }),
  }),
});

export const {
  useGetNewsQuery,
  useGetSystemNewsQuery,
  useGetNewsByIdQuery,
  useUpdateNewsUserStateMutation,
  useCreateNewsMutation,
  useUpdateNewsMutation,
  useDeleteNewsMutation,
} = newsApiSlice;
